import { render, staticRenderFns } from "./ElementStudioDependencies.vue?vue&type=template&id=60b49613&"
import script from "./ElementStudioDependencies.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioDependencies.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioDependencies.vue?vue&type=style&index=0&id=60b49613&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports